import { EditorService } from './editor';
import { StoreService } from './store';
var instanceMap = new Map();
var Plugin = /** @class */ (function () {
    function Plugin(editorId, editor) {
        this.editorId = editorId;
        this.editor = editor;
        this.editorService = new EditorService(this);
        this.storeService = new StoreService(this);
    }
    Plugin.getInstance = function (config) {
        var _a = config || {}, editorId = _a.editorId, editor = _a.editor;
        if (!editorId) {
            editorId = 'default';
        }
        if (!instanceMap.has(editorId)) {
            instanceMap.set(editorId, new Plugin(editorId, editor));
        }
        return instanceMap.get(editorId);
    };
    return Plugin;
}());
export { Plugin };
